import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Martina Gómez',
  city: 'Rosario',
  initials: 'MG',
  text: 'Mi bulldog francés vivía con alergias y la piel roja. Gasté fortunas en alimentos hipoalergénicos sin resultado. Desde que empezamos con esta guía hace un mes, la picazón desapareció por completo. ¡Toby es otro perro!',
  dog: 'Toby'
}, {
  name: 'Lucas Fernández',
  city: 'Córdoba',
  initials: 'LF',
  text: 'Pensé que cocinarle iba a ser súper complicado y caro, pero el libro te explica todo tan fácil que preparo las viandas de toda la semana en un par de horas. Rocco tiene mucha más energía y el pelo le brilla como nunca.',
  dog: 'Rocco'
}, {
  name: 'Sofía Martínez',
  city: 'Mendoza',
  initials: 'SM',
  text: 'Lola tenía problemas digestivos constantes con las croquetas. La transición fue súper suave gracias al paso a paso del libro. Ahora come con unas ganas que no veía hace años y sus digestiones son perfectas.',
  dog: 'Lola'
}, {
  name: 'Diego Rodríguez',
  city: 'La Plata',
  initials: 'DR',
  text: 'Excelente material. Muy claro y directo al grano. Me dio la seguridad que necesitaba para dejar el balanceado. A mi ovejero alemán le cambió hasta el humor, está mucho más activo y feliz.',
  dog: 'Rex'
}, {
  name: 'Carolina Sosa',
  city: 'Buenos Aires',
  initials: 'CS',
  text: 'Lo mejor que pude haber comprado. Milo sufría de otitis recurrentes por culpa del alimento comercial. Cambiamos a la dieta natural siguiendo las recetas y no volvió a tener problemas. ¡Gracias!',
  dog: 'Milo'
}];
export function Testimonials() {
  return <section className="py-12 md:py-16 px-4 bg-cream" data-id="element-203">
      <div className="max-w-6xl mx-auto" data-id="element-204">
        <div className="text-center mb-8 md:mb-10" data-id="element-205">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-primary mb-4" data-id="element-206">
            Familias que ya transformaron la vida de sus perros
          </h2>
          <p className="text-lg text-brown-light max-w-2xl mx-auto" data-id="element-207">
            Más de 5.000 perros en toda Argentina ya disfrutan de una
            alimentación real.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-208">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-cream-dark flex flex-col h-full" data-id="element-209">
              <div className="flex gap-1 text-accent mb-4" data-id="element-210">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-211" />)}
              </div>

              <p className="text-brown-light italic mb-6 flex-grow" data-id="element-212">
                "{t.text}"
              </p>

              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-cream-dark" data-id="element-213">
                <div className="w-10 h-10 rounded-full bg-primary-light flex items-center justify-center text-white font-bold text-sm" data-id="element-214">
                  {t.initials}
                </div>
                <div data-id="element-215">
                  <p className="font-bold text-primary text-sm" data-id="element-216">{t.name}</p>
                  <p className="text-xs text-brown-light" data-id="element-217">
                    {t.city} • Dueño/a de {t.dog}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}